import React, { useEffect, useState } from "react";
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http';
import "./aisCustom.css";

import ChartComponent from "./ChartComponent";

import Select from "react-select";
import ChartLoader from "../Charginganalysis/ChartLoader";

export default function ChartSecond(props) {
  const [langTwo, setLangTwo] = useState(null);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [secondOption, setSecondOption] = useState("")
  const [typeTitleSecond, setTypeTitleSecond] = useState("")
  const [chartDataSec, setChartDataSec] = useState([])

  const handleLanguageChangeSecond = (obj) => {
    setSecondOption(obj.code)
    setLangTwo(obj);
    setTypeTitleSecond(obj.code)
    fetchData({ url: API_URL_MAIN + "arai/getData", body: { filterdata: props.filterObject } }, appyDataSec)
  };
  const [orgChartData, setorgChartData] = useState([])
  const appyDataSec = (data) => {
    setorgChartData(data)
  }
  useEffect(() => {
    var output = orgChartData.map((s, index) => (
      { "date": new Date(s._source.eventdatetime).getTime(), "value": s._source.hasOwnProperty(secondOption) ? Number(s._source[secondOption]) : null })
    );
    setChartDataSec(output);
  }, [orgChartData])

  return (
    <div className="col-lg-12 col-md-12 col-sm-12 mb-3">
      <div className="aisChartbox aisWd">
        <div className="v-title aisTitleChart">
          <div className="row p-1">
            <div className="col-lg-9 col-md-9 col-sm-9 col-9">
              <h6 className="mt-2 pl-2">{typeTitleSecond}</h6>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <Select
                placeholder="Select"
                value={langTwo}
                options={props.langList}
                onChange={handleLanguageChangeSecond}
                getOptionLabel={x => x.name}
                getOptionValue={x => x.code}
              />
            </div>
          </div>
        </div>
        {
          (isLoading) ? <ChartLoader /> :
            <div className="d-flex align-items-end flex-column"><ChartComponent chartId={"chartdiv_second"} selected={secondOption} filterObject={props.filterObject} dynamicInterval={props.dynamicInterval} chartData={chartDataSec} /></div>
        }
      </div>
    </div>
  );
}
